// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1e937c0e","455":"49971972","977":"9ab4095f"}[chunkId] + ".chunk.js";
};